module.exports = __webpack_public_path__ + "static/img/security.c8a5d9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/security.svg
// module id = Ei1T
// module chunks = 0